export default {
    apiURL: 'https://admin-api-dot-kiwicheckout.appspot.com',
}
// http://localhost:3001
// https://admin-api-dot-kiwicheckout.appspot.com